/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Imagecaption1Inputs */

const en_gc_search_guides_what_is_gridcraft_imagecaption1 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Imagecaption1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A real GridCraft workspace with the sales sample loaded. Screenshot: ArtCraft.`)
};

const zh_gc_search_guides_what_is_gridcraft_imagecaption1 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Imagecaption1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`载入销售示例的真实 GridCraft 工作区。截图来源：ArtCraft。`)
};

/**
* | output |
* | --- |
* | "A real GridCraft workspace with the sales sample loaded. Screenshot: ArtCraft." |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Imagecaption1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_imagecaption1 = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Imagecaption1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Imagecaption1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_imagecaption1(inputs)
	return zh_gc_search_guides_what_is_gridcraft_imagecaption1(inputs)
});
export { gc_search_guides_what_is_gridcraft_imagecaption1 as "gc.search_guides.what_is_gridcraft.imageCaption" }